<template>
  <PageContainer>
    <SectionContainer class="pt-2">
      <h1>Entourage</h1>
      <img src="@/assets/bridal-party.png">
      <img src="@/assets/sponsors.png">
    </SectionContainer>
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'

export default {
  name: 'EntouragePage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
}
</script>